// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SelectableConversationList Styles
 * Pixel-perfect implementation based on Figma design
 */

.selectable-conversation-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* Selectable Item */
.selectable-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  user-select: none;
}

.selectable-item:hover {
  background-color: #F8F8F8;
}

.selectable-item.selected {
  background-color: #FFFFFF;
}

.selectable-item:focus {
  outline: none;
  background-color: #F8F8F8;
}

.selectable-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: auto;
}

.selectable-item.disabled:hover {
  background-color: transparent;
}

.selectable-item.disabled .selectable-item-checkbox {
  border-color: #E5E5E5;
  background-color: #F5F5F5;
}

/* Checkbox (Circle style) */
.selectable-item-checkbox {
  width: 24px;
  height: 24px;
  min-width: 24px;
  border: 2px solid #D8D8D8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  background-color: #FFFFFF;
}

.selectable-item-checkbox.checked {
  background-color: #DE4858;
  border-color: #DE4858;
}

.selectable-item-checkmark {
  color: #FFFFFF;
  font-size: 10px;
}

/* Avatar Container */
.selectable-item-avatars {
  position: relative;
  width: 60px;
  height: 60px;
  min-width: 60px;
}

/* Lock Icon for Encrypted Rooms */
.selectable-item-lock-icon {
  position: absolute;
  top: -2px;
  left: -17px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selectable-item-lock-icon .fa-lock {
  color: rgb(153, 153, 153);
  font-size: 16px;
}

/* Single Avatar */
.selectable-item-avatar-single {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
}

/* Dual Avatars */
.selectable-item-avatar-first {
  position: absolute;
  width: 43px;
  height: 43px;
  top: -1px;
  left: -1px;
  border-radius: 50%;
  object-fit: cover;
}

.selectable-item-avatar-second {
  position: absolute;
  width: 43px;
  height: 43px;
  top: 18px;
  left: 18px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #FFFFFF;
}

/* Placeholder Avatar */
.selectable-item-avatar-placeholder {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #000000;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 24px;
  font-weight: 600;
  text-transform: uppercase;
}

.selectable-item-avatar-placeholder-first {
  position: absolute;
  width: 43px;
  height: 43px;
  top: -1px;
  left: -1px;
  border-radius: 50%;
  background-color: #000000;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
}

.selectable-item-avatar-placeholder-second {
  position: absolute;
  width: 43px;
  height: 43px;
  top: 18px;
  left: 18px;
  border-radius: 50%;
  background-color: #000000;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  font-weight: 600;
  text-transform: uppercase;
  border: 2px solid #FFFFFF;
}

/* Name */
.selectable-item-name {
  flex: 1;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0;
  color: #2E2E2E;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectableConversationList.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,OAAO;EACP,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":["/**\n * SelectableConversationList Styles\n * Pixel-perfect implementation based on Figma design\n */\n\n.selectable-conversation-list {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* Selectable Item */\n.selectable-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 24px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  user-select: none;\n}\n\n.selectable-item:hover {\n  background-color: #F8F8F8;\n}\n\n.selectable-item.selected {\n  background-color: #FFFFFF;\n}\n\n.selectable-item:focus {\n  outline: none;\n  background-color: #F8F8F8;\n}\n\n.selectable-item.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n\n.selectable-item.disabled:hover {\n  background-color: transparent;\n}\n\n.selectable-item.disabled .selectable-item-checkbox {\n  border-color: #E5E5E5;\n  background-color: #F5F5F5;\n}\n\n/* Checkbox (Circle style) */\n.selectable-item-checkbox {\n  width: 24px;\n  height: 24px;\n  min-width: 24px;\n  border: 2px solid #D8D8D8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n  background-color: #FFFFFF;\n}\n\n.selectable-item-checkbox.checked {\n  background-color: #DE4858;\n  border-color: #DE4858;\n}\n\n.selectable-item-checkmark {\n  color: #FFFFFF;\n  font-size: 10px;\n}\n\n/* Avatar Container */\n.selectable-item-avatars {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  min-width: 60px;\n}\n\n/* Lock Icon for Encrypted Rooms */\n.selectable-item-lock-icon {\n  position: absolute;\n  top: -2px;\n  left: -17px;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.selectable-item-lock-icon .fa-lock {\n  color: rgb(153, 153, 153);\n  font-size: 16px;\n}\n\n/* Single Avatar */\n.selectable-item-avatar-single {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* Dual Avatars */\n.selectable-item-avatar-first {\n  position: absolute;\n  width: 43px;\n  height: 43px;\n  top: -1px;\n  left: -1px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.selectable-item-avatar-second {\n  position: absolute;\n  width: 43px;\n  height: 43px;\n  top: 18px;\n  left: 18px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #FFFFFF;\n}\n\n/* Placeholder Avatar */\n.selectable-item-avatar-placeholder {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  background-color: #000000;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 24px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.selectable-item-avatar-placeholder-first {\n  position: absolute;\n  width: 43px;\n  height: 43px;\n  top: -1px;\n  left: -1px;\n  border-radius: 50%;\n  background-color: #000000;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.selectable-item-avatar-placeholder-second {\n  position: absolute;\n  width: 43px;\n  height: 43px;\n  top: 18px;\n  left: 18px;\n  border-radius: 50%;\n  background-color: #000000;\n  color: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: 2px solid #FFFFFF;\n}\n\n/* Name */\n.selectable-item-name {\n  flex: 1;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 100%;\n  letter-spacing: 0;\n  color: #2E2E2E;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
